<template>
    <div class="mobile-nav-wrapper pb-3 d-lg-none d-sm-block">
        <div class="cards" v-if="$store.state.showNavigation">
            <div class="card"
                 :class="{ active: isActive(step.index), finished: isFinished(step.index), hidden: isHidden(step.index)}"
                 v-for="(step, idx) in this.$store.getters.activeStepsArray"
                 @click="clickStep(step.index)"
            >
          <span class="step-number">
            <span class="text">
                {{idx+1}}
            </span>
            <i :class="`${$store.state.faClass} fa-check`"></i>
          </span>
                <div class="title">
                    {{step.title}}
                </div>
            </div>
        </div>
        <div class="progress">
            <div class="progress-bar" :style="{width: getProgress('%')}"
                 role="progressbar" aria-label="Fortschritt"
                 :aria-valuenow="getProgress('')" aria-valuemin="0" aria-valuemax="100">{{getProgress(' %')}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        mounted() {

        },
        methods: {
            cardCount() {
                return this.$store.getters.activeStepsCount;
            },
            isActive(index) {
                return index === this.$store.state.currentStepIndex;
            },
            isFinished(index) {
                return index < this.$store.state.currentStepIndex;
            },
            isHidden(index) {
                if (this.cardCount() <= 3) {
                    return false;
                }
                const maxDiff = this.$store.state.currentStepIndex > 0 && this.$store.state.currentStepIndex < this.cardCount() - 1 ? 1 : 2;
                if (Math.abs(index - this.$store.state.currentStepIndex) > maxDiff) {
                    return true;
                }
                return false;
            },
            clickStep(index) {
                this.$parent.clickStep(index);
            },
            getProgress(suffix, idx) {
                // let progress = this.$store.step.renderThankYou ? 100 : Math.round(this.$store.getters.activeStepIndex / this.cardCount() * 100);
                let progress;
                if (this.$store.state.showNavigation) {
                    progress = Math.round(this.$store.getters.activeStepIndex / this.cardCount() * 100);
                } else {
                    progress = 100;
                }
                progress += suffix;
                return progress;
            }
        }
    }
</script>